import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { MFieldProps } from '../types';
import { StringDateInput } from '@mc/react-datetime';
import { useTheme } from '../useTheme';
import { FormItem } from './FormItem';
import classNames from 'classnames';
import { Radio } from '@mc/react-core';

export type DateProps = MFieldProps<
  React.ComponentProps<typeof StringDateInput>
>;
export const RadioInput = React.forwardRef<HTMLInputElement, DateProps>(
  (
    {
      children,
      name,
      validate,
      className,
      inputClassName,
      disabled,
      required,
      label,
      value,
      ...other
    },
    ref
  ) => {
    const { ns } = useTheme();

    return (
      <>
        <FormItem
          name={name}
          className={className}
          disabled={disabled}
          required={required}
        >
          <Field name={name} type={'radio'} value={value}>
            {({
              input: {
                value,
                checked,
                name,
                onChange,
                onFocus,
                onBlur,
                ...nother
              },
            }: FieldRenderProps<string>) => {
              return (
                <Radio
                  name={name}
                  checked={checked}
                  value={value}
                  onChange={onChange}
                  label={label}
                  {...other}
                  {...nother}
                  disabled={disabled}
                  ref={ref}
                  className={classNames(`${ns}-radio`, inputClassName)}
                >
                  {children}
                </Radio>
              );
            }}
          </Field>
        </FormItem>
      </>
    );
  }
);
